import React from 'react';

import SwitchLink from '../links/switchLink';
import { useFooterQuery } from '@querys/useFooterQuery';
import { SanityImage } from '@components/sanity/sanityImage';

export const SmallLinks = () => {
  const { footer } = useFooterQuery();

  return (
    <div className='opacity-50 text-white blockH9 text-center lg:text-left mt-8 lg:mt-0'>
      <div className='flex gap-x-4 justify-center lg:justify-start'>
        {footer?.footerSmallLinks?.map((link, i) => (
          <SwitchLink key={i} {...link} />
        ))}
      </div>
      <span className='block mt-3'>
        Chamber Music New Zealand. All Rights Reserved.
      </span>
    </div>
  );
};

export const MainLinks = () => {
  const { footer } = useFooterQuery();

  return (
    <div className='grid grid-cols-3 gap-x-14 gap-y-2'>
      {footer?.footerLinks?.map((link, i) => (
        <SwitchLink
          key={i}
          {...link}
          className='blockH8 hover:opacity-60 transition-standard'
          activeStyle={{ opacity: '60%' }}
        />
      ))}
    </div>
  );
};

export const Socials = () => {
  const { social } = useFooterQuery();

  return (
    <div className='my-10 md:my-14 flex flex-col lg:flex-row gap-y-6 gap-x-7 items-center'>
      <span className='blockH8 font-bold'>Stay Connected</span>
      <div className='flex gap-x-8 items-center'>
        {social?.socialHandles?.map(({ svg, link }, i) => (
          <a
            key={i}
            href={link}
            target='_blank'
            rel='noreferrer'
            dangerouslySetInnerHTML={{ __html: svg }}
            className='footer-socials scale-[1.35]'
          />
        ))}
      </div>
    </div>
  );
};

export const Supporters = () => {
  const { footer } = useFooterQuery();

  return (
    <div className='flex flex-col gap-y-8 lg:flex-row gap-x-14'>
      {footer?.supporters?.map(({ image, title, url }, i) => (
        <a
          key={i}
          href={url}
          target='_blank'
          rel='noreferrer'
          className='w-full flex flex-col gap-y-3 justify-between items-center lg:items-start'>
          <span className='blockH9 font-bold'>{title}</span>
          {image && (
            <SanityImage image={image} className='h-[40px] lg:ml-1 mx-auto' />
          )}
        </a>
      ))}
    </div>
  );
};
